
export default {
    name: "PercentBox",

    props: {
        originText: {
            type: String,
            default: '',
        }
    },

    computed: {
        isEmpty() {
            return this.originText === '-' || !this.originText;
        },
        displayedText() {
            return this.originText?.charAt(0) === '-' ? this.originText : `+${this.originText}` ;
        }
    },

    methods: {
        getPercentClass() {
            return this.originText?.charAt(0) == '-' ? 'negative-box' : 'positive-box';
        }
    }
};
